 
import PlanOptionWrap from "./planoptionswrap"

const Plans=()=>{
    return(<>
    
    <PlanOptionWrap/>
    </>)
}
export default Plans